export class SexAtBirthLang {
    public Female: string;
    public Male: string;
}


// WEBPACK FOOTER //
// ./src/resources/SexAtBirthLang.ts